var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2991",
    transform: "translate(0 1280)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2993",
    d: "M7.692-1261.818a1.923,1.923,0,0,1-.451,1.285,1.378,1.378,0,0,1-1.088.533,1.378,1.378,0,0,1-1.088-.533,1.923,1.923,0,0,1-.451-1.285,1.923,1.923,0,0,1,.451-1.285,1.378,1.378,0,0,1,1.088-.533,1.378,1.378,0,0,1,1.088.533A1.923,1.923,0,0,1,7.692-1261.818Zm10.769,0a1.923,1.923,0,0,1-.451,1.285,1.378,1.378,0,0,1-1.088.533,1.378,1.378,0,0,1-1.088-.533,1.923,1.923,0,0,1-.451-1.285,1.923,1.923,0,0,1,.451-1.285,1.378,1.378,0,0,1,1.088-.533,1.378,1.378,0,0,1,1.088.533A1.923,1.923,0,0,1,18.462-1261.818ZM20-1277.273V-1270a1,1,0,0,1-.192.6.718.718,0,0,1-.493.305l-12.548,1.733c.008.066.026.168.054.305s.052.263.072.376a1.812,1.812,0,0,1,.03.313,3.082,3.082,0,0,1-.288.909H17.692a.689.689,0,0,1,.541.27.958.958,0,0,1,.228.639.958.958,0,0,1-.228.639.689.689,0,0,1-.541.27H5.385a.689.689,0,0,1-.541-.27.958.958,0,0,1-.228-.639,1.785,1.785,0,0,1,.132-.561q.132-.362.355-.845t.246-.54l-2.127-11.69H.769a.688.688,0,0,1-.541-.27.958.958,0,0,1-.228-.639.958.958,0,0,1,.228-.639.689.689,0,0,1,.541-.27H3.846a.643.643,0,0,1,.343.092.8.8,0,0,1,.24.22,1.207,1.207,0,0,1,.156.348,2.852,2.852,0,0,1,.09.376q.024.156.066.419t.054.362H19.231a.689.689,0,0,1,.541.27A.958.958,0,0,1,20-1277.273Z",
    transform: "translate(0 0)",
    fill: "#b82f00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.b3578edd8d1dfe85e95d5493ec6d0132.svg";
export { ForwardRef as ReactComponent };